import { RequestService } from "../../../../common/services/RequestService";
import { DELETE_PERSON } from "./constants";

export const deletePersonRequest = async (orderId, profileId) => {
  const response = await RequestService.delete(
    DELETE_PERSON.replace("{order_id}", orderId).replace(
      "{person_id}",
      profileId
    )
  );
  return response;
};
